@if (!editMode) {
  <div class="line-content">
    <div
      class="lotto-line-form-field"
      (mouseenter)="hoverMode = true"
      (mouseleave)="hoverMode = false"
      [style.height]="tableMode && !hoverMode ? '30px' : 'auto'">
      @for (selection of data; track selection) {
        <display-selected-line
          class="display-selected-line"
          [readonly]="true"
          [drawOption]="selection.drawOptionInstance"
          [selections]="selection.picked">
        </display-selected-line>
      }
    </div>
    @if (tableMode && allSelectionsLength > 7 && !hoverMode) {
      <span class="line-info">...</span>
    }
  </div>
} @else {
  <span [formGroup]="formGroup" class="example-full-width">
    @for (selection of data; track selection) {
      <display-selected-line
        class="display-selected-line"
        [readonly]="false"
        [drawOption]="selection.drawOptionInstance"
        [selections]="selection.picked">
      </display-selected-line>
    }
  </span>
}
